export default __webpack_public_path__ + "static/media/temporary-2.b2147b2e.svg";